<template>
  <div id="app">
    <!-- Full page loader -->
    <b-loading :is-full-page="isFullPage" :active.sync="isLoading" :can-cancel="false"></b-loading>
    <!-- Components -->
    <Header id="header"/>
    <router-view/>
  </div>
</template>

<script>
import Header from './components/Header'
import { mapGetters } from 'vuex'

export default {
  name: 'App',
  components: {
    Header
  },
  data: function () {
    return {
      isFullPage: true
    }
  },
  computed: {
    ...mapGetters('authentication', ['isAuthenticated', 'authStatus']),
    isLoading: function () {
      return this.authStatus === 'loading'
    }
  }
}
</script>

<style lang="scss">
html {
  background-color: #ffffff;
}
body {
  height: 100vh;
  background-color: #ffffff;
}
@media (min-width: 770px) {
  html,
  body {
    overflow-y: hidden !important;
  }
}
#app {
  height: 100%;
}
$header-height: 56px;

.planning-content {
  height: calc(100% - (#{$header-height} + 5px));
  padding-top: 5px;
}

// Import Bulma's core
@import "~bulma/sass/utilities/_all";
@import "../node_modules/@mdi/font/css/materialdesignicons.min.css";

$family-primary: "Helvetica Neue", Helvetica, Arial, sans-serif;

// Set your colors
$primary: #448993;
$primary-invert: findColorInvert($primary);
$light-blue: #70aab3;
$light-blue-invert: findColorInvert($light-blue);
$twitter: #448993;
$secondary: #ac936c;
$secondary-invert: findColorInvert($secondary);
$twitter-invert: findColorInvert($twitter);
$danger: #b65640;
// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
  "white": (
    $white,
    $black
  ),
  "black": (
    $black,
    $white
  ),
  "light": (
    $light,
    $light-invert
  ),
  "dark": (
    $dark,
    $dark-invert
  ),
  "primary": (
    $primary,
    $primary-invert
  ),
  "secondary": (
    $secondary,
    $secondary-invert
  ),
  "light-blue": (
    $light-blue,
    $light-blue-invert
  ),
  "info": (
    $info,
    $info-invert
  ),
  "success": (
    $success,
    $success-invert
  ),
  "warning": (
    $warning,
    $warning-invert
  ),
  "danger": (
    $danger,
    $danger-invert
  ),
  "twitter": (
    $twitter,
    $twitter-invert
  )
);
// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

.content ul {
  list-style: none !important;
  margin-left: 0px !important;
  margin-top: 0px !important;
}
.content li + li {
  margin-top: 0px !important;
}

/** Custom design for tables **/
table.table.is-narrow.has-mobile-cards.is-hoverable:focus {
  outline: 0;
}
.b-table .table:focus {
  border: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
$pagination-height: calc(51px + 1.5rem);
.table-wrapper {
  height: calc(100% - #{$pagination-height});
  overflow-y: auto;
  overflow-x: hidden;
}
// specific to InvoiceSummary table
.summary-table .table-wrapper {
  height: calc(100% - 1.5rem);
  overflow-y: auto;
  overflow-x: hidden;
}
// custom line css to highligh invoice items with default price
.is-info {
  background: $secondary;
  color: #fff !important;
}
/** END Custom design for tables **/

/** Custom design for tabs **/
.b-tabs {
  height: 100%;
}
.tabs {
  overflow-x: auto;
}
// make the tab button height like others
.tabs li,
.tabs a {
  height: 101%;
}
.tab-content {
  // Same height as master list
  height: calc(100% - #{$pagination-height});
}
.tab-item,
.summary {
  height: 100%;
}
.slip {
  height: 125%;
}
/** END Custom design for tabs **/

/*
  *  Scrollbar style
  */
.table-wrapper::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(68, 137, 147, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

.table-wrapper::-webkit-scrollbar {
  width: 5px;
  background-color: #f5f5f5;
}

.table-wrapper::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(68, 137, 147, 0.3);
  background-color: $light-blue;
}
.tabs::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(68, 137, 147, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

.tabs::-webkit-scrollbar {
  height: 8px;
  background-color: #f5f5f5;
}

.tabs::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(68, 137, 147, 0.3);
  background-color: $light-blue;
}

.card::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  background-color: #f5f5f5;
}

.card::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(68, 137, 147, 0.3);
  background-color: $light-blue;
}

/** END Scrollbar **/

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";
</style>
